import { BookingJourneyStep, WizardSteps } from "utils/types";
import { BookingJourneyState } from "store/bookingJourney";
import { dateAndLocationWizardStep } from "./wizards/dateAndLocationWizardStep";

export const moveStepForward = (state: BookingJourneyState) => {
  const keys = Object.keys(BookingJourneyStep);
  const currentIndex = keys.indexOf(state.currentStep);
  const newStep = keys[currentIndex + 1] as BookingJourneyStep;
  if (newStep !== undefined) {
    state.currentStep = newStep;
    if (wizardSteps[newStep].skip?.(state)) {
      moveStepForward(state);
    } 
  }
};

export const moveStepBackward = (state: BookingJourneyState) => {
  const keys = Object.keys(BookingJourneyStep);
  const currentIndex = keys.indexOf(state.currentStep);
  const newStep = keys[currentIndex - 1] as BookingJourneyStep;
  if (newStep !== undefined) {
    state.currentStep = newStep;
    if (wizardSteps[newStep].skip?.(state)) {
      moveStepBackward(state);
    } 
  }
};

export const wizardSteps: WizardSteps = {
  [BookingJourneyStep.Summary]: {},
  [BookingJourneyStep.DateAndLocation]: dateAndLocationWizardStep,
  [BookingJourneyStep.HostDelegatesPage]: {},
  [BookingJourneyStep.Payment]: {},
  [BookingJourneyStep.Review]: {},
  [BookingJourneyStep.Complete]: {},
};
